<template>
  <card no-body class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
    <template slot="header">
      <h3 class="mb-0">{{ title }}</h3>
      <b-row class="my-3">
        <b-col md="6">
          <b-input-group>
            <template #prepend>
              <b-dropdown variant="outline-danger">
                <template #button-content>
                  {{ rangeTitle }}
                </template>
                <b-dropdown-item v-for="item in ranges" :key="item.value" @click="range = item.value">{{ item.label }}</b-dropdown-item>
              </b-dropdown>
            </template>
            <b-form-datepicker v-model="start_date" locale="en" :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"></b-form-datepicker>
            <b-form-datepicker v-model="end_date" locale="en" :min="start_date" :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"></b-form-datepicker>
          </b-input-group>
        </b-col>
        <b-col md="2">
          <daily-items-views :columns="tableColumns" :trackingSources="trackingSources"></daily-items-views>
        </b-col>
        <b-col md="2">
          <el-select
            class="select-primary pagination-select"
            v-model="pagination.perPage"
            placeholder="Per page"
          >
            <el-option
              class="select-primary"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </b-col>
        <b-col md="2">
          <b-button variant="danger" @click="exportTracking">Export Results</b-button>
        </b-col>
      </b-row>
    </template>
    <div>
      <b-table responsive small :busy="isBusy" :items="tableData" :perPage="pagination.perPage" :currentPage="pagination.currentPage" :fields="visibleColumns" :filter="searchQuery">
        <template #cell(actions)="row">
          <b-dropdown text="Actions" size="sm" variant="info" boundary="viewport">
            <b-dropdown-item variant="primary" @click="handleEdit(row)"><i class="fa fa-edit"></i> Edit</b-dropdown-item>
            <b-dropdown-item variant="danger" @click="handleDelete(row)"><i class="fa fa-trash"></i> Delete</b-dropdown-item>
            <b-dropdown-item variant="info" @click="commentsModal(row)"><i class="fa fa-edit"></i> Notes</b-dropdown-item>
          </b-dropdown>
        </template>
        <template v-for="source in trackingSources" v-slot:[toCellName(source.slug)]="row">
          {{ row.item.tracking_sources[source.slug].value }}
        </template>
      </b-table>
    </div>
    <div
      slot="footer"
      class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
    >
      <div class="">
        <p class="card-category">
          Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

          <span v-if="selectedRows.length">
            &nbsp; &nbsp; {{selectedRows.length}} rows selected
          </span>
        </p>

      </div>
      <base-pagination
        class="pagination-no-border"
        :current="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
        @change="paginationChanged($event)"
      >
      </base-pagination>
    </div>
    <comments-modal :type="'daily-items'"
                 :typeId="typeId"
                 :userRoute="userRoute">
    </comments-modal>
    <tracking-source-modal
      :userRoute="userRoute" 
      :trackingSources="trackingSources"
      :type="'daily_items'"
      @getItems="getItems"
      @getTrackingSources="getTrackingSources">
    </tracking-source-modal>
  </card>
</template>
<script>
import axios from 'axios';
import swal from 'sweetalert2';
import { Select, Option } from 'element-ui';
import { format } from 'date-fns'
import { BasePagination } from '@/components';
import paginationMixin from '../Tables/PaginatedTables/paginationMixin';
import errorsMixin from '@/mixins/errors-mixin';
import CommentsModal from '@/views/Components/Modals/CommentsModal';
import DailyItemsViews from './Views/DailyItemsViews';
import TrackingSourceModal from '@/views/Components/Modals/TrackingSourceModal';
import columns from '@/views/Portal/DailyItems/columns';

export default {
  mixins: [paginationMixin, errorsMixin],
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    CommentsModal,
    DailyItemsViews,
    TrackingSourceModal
  },
  props: {
    title: null,
    userRoute: null,
  },
  data() {
    return {
      propsToSearch: [],
      tableData: [],
      tableColumns: columns,
      trackingSources: null,
      selectedRows: [],
      years: [
        { value: new Date().getFullYear() - 6, label: new Date().getFullYear() - 6 },
        { value: new Date().getFullYear() - 5, label: new Date().getFullYear() - 5 },
        { value: new Date().getFullYear() - 4, label: new Date().getFullYear() - 4 },
        { value: new Date().getFullYear() - 3, label: new Date().getFullYear() - 3 },
        { value: new Date().getFullYear() - 2, label: new Date().getFullYear() - 2 },
        { value: new Date().getFullYear() - 1, label: new Date().getFullYear() - 1 },
        { value: new Date().getFullYear(), label: new Date().getFullYear() },
        { value: new Date().getFullYear() + 1, label: new Date().getFullYear() + 1 },
        { value: new Date().getFullYear() + 2, label: new Date().getFullYear() + 2 },
        { value: new Date().getFullYear() + 3, label: new Date().getFullYear() + 3 },
      ],
      typeId: null,
      row: null,
      start_date: new Date(new Date().getFullYear(), 0, 1),
      end_date: new Date(new Date().getFullYear(), 11, 31),
      range: 0,
      ranges: [
        { value: 0, label: "Current Year" },
        { value: 1, label: "Yesterday" },
        { value: 2, label: "Last 7 Days" },
        { value: 3, label: "Current Month" },
        { value: 4, label: "Last 3 Months" },
      ],
      isBusy: null
    };
  },
  computed: {
    visibleColumns() {
      return this.tableColumns.filter(column => {
        return column.visible == true;
      });
    },
    rangeTitle() {
      return this.ranges.filter((item) => {
        return item.value == this.range;
      })[0].label;
    },
  },
  methods: {
    async getItems() {
      let startDate = new Date(this.start_date).toLocaleDateString("en-US");
      let endDate = new Date(this.end_date).toLocaleDateString("en-US");

      await axios.get(this.userRoute + "/daily-items?start_date=" + startDate + "&end_date=" + endDate)
      .then(response => {
        this.tableData = response.data;
        this.isBusy = false;
        this.$emit('updateItemsCount', this.tableData.length);
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getTrackingSources() {
      await axios.get(this.userRoute + "/tracking-sources")
      .then(response => {
        this.trackingSources = response.data;
        this.addSourcesToColumns();
      })
      .catch(error => {
        this.error(error);
      })
    },
    paginationChanged(page) {
      this.pagination.currentPage = page
    },
    handleEdit(row) {
      const path = this.$route.fullPath + '/' + row.item.id;

      this.$router.push({
        path: path
      });
    },
    async handleUpdate(row) {
      axios.patch(this.$store.getters.user_route + "/daily-items/" + row.item.id, row.item)
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    handleDelete(row) {
      swal.fire({
        title: 'Are you sure?',
        text: `You won't be able to revert this!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(row);
          swal.fire({
            title: 'Deleted!',
            text: `Your daily items have been deleted.`,
            type: 'success',
            showConfirmButton: false,
            timer: 1500,
            icon: 'success'
          });
        }
      });
    },
    async deleteRow(row) {
      axios.delete(this.userRoute + "/daily-items/" + row.item.id)
      .then(response => {
        this.tableData.splice(row.index, 1);
      })
      .catch(error => {
        this.error(error);
      })
    },
    handleCancel() {
      this.editable = null;
    },
    commentsModal(row) {
      this.typeId = row.item.id;
      this.$bvModal.show('comments-modal');
    },
    toCellName (slot) {
      return `cell(${slot})`
    },
    updateRange() {
      switch(this.range) {
        case 0:
          this.start_date = new Date(new Date().getFullYear(), 0, 1);
          this.end_date = new Date(new Date().getFullYear(), 11, 31);
          break;
        case 1:
          var date = new Date();
          var start_date = new Date(date.setDate(date.getDate() - 1))
          this.start_date = start_date;
          this.end_date = start_date;
          break;
        case 2:
          var date = new Date();
          var start_date = new Date(date.setDate(date.getDate() - 7))
          this.start_date = start_date;
          this.end_date = new Date();
          break;
        case 3:
          var date = new Date();
          var start_date = new Date(date.setDate(date.getDate() - date.getDate() + 1))
          this.start_date = start_date;
          this.end_date = new Date();
          break;
        case 4:
          var date = new Date();
          var start_date = new Date(date.setDate(date.getDate() - 84))
          this.start_date = start_date;
          this.end_date = new Date();
          break;
        default:
          this.start_date = new Date(new Date().getFullYear(), 0, 1);
          this.end_date = new Date(new Date().getFullYear(), 11, 31);
      }
    },
    addSourcesToColumns() {
      this.trackingSources.forEach(source => {
        this.tableColumns.push({
          key: source.slug,
          label: source.name,
          sortable: true,
          visible: true
        });
      });
    },
    exportTracking() {
      let startDate = new Date(this.start_date).toLocaleDateString("en-US");
      let endDate = new Date(this.end_date).toLocaleDateString("en-US");

      axios.get(this.userRoute + "/export-daily-items?start_date=" + startDate + "&end_date=" + endDate)
      .then(response => {
        swal.fire({
          title: 'Export Complete',
          text: response.data.message,
          icon: 'success',
          confirmButtonColor: '#009347',
          confirmButtonText: 'Download Daily Tracking',
        }).then(result => {
          if (result.value) {
            window.open(response.data.link, "_blank");
          }
        });
      })
      .catch(error => {
        this.error(error);
      })
    }
  },
  created() {
    this.getItems();
    this.getTrackingSources();
  },
  watch: {
    range(to, from) {
      this.updateRange();
      this.getItems();
    },
    start_date(to, from) {
      this.getItems();
    },
    end_date(to, from) {
      this.getItems();
    },
  }
};
</script>
<style>
  .no-border-card .card-footer{
    border-top: 0;
  }
</style>